<template>
  <b-overlay :show="isLoading" rounded="sm">
    <div v-if="tags !== null">
      <!-- Table Container Card -->
      <b-card class="mb-0">
        <h1>Tags</h1>
        <div class="my-2">
          <!-- Table Top -->
          <b-row class="w-100">
            <b-col
                cols="12"
                class="d-flex align-items-center"
            >
              <b-row>
                <b-col cols="6">
                  <div class="form-label-group">
                    <b-form @submit.prevent>
                      <b-form-group label="Tag Name" label-for="name">
                        <b-form-input
                            id="name"
                            placeholder="best offer"
                            v-model="defaultCreateData.tagName"
                        />
                      </b-form-group>
                    </b-form>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form @submit.prevent>
                    <b-form-group label="Seo title" label-for="seoTitle">
                      <b-form-input
                          id="seoTitle"
                          trim
                          placeholder="best offer"
                          v-model="defaultCreateData.seoTitle"
                      />
                    </b-form-group>
                  </b-form>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form @submit.prevent>
                    <b-form-group label="Seo Url" label-for="seoURL">
                      <b-form-input
                          id="seoURL"
                          trim
                          placeholder="best-offer"
                          v-on:focus="$event.target.select()"
                          v-model="allCharactersToDash"
                      />
                    </b-form-group>
                  </b-form>
                </b-col>
                <b-col cols="12">
                  <b-form @submit.prevent>
                    <b-form-group label="Seo Description" label-for="seoDescription">
                      <b-form-textarea
                          id="seoDescription"
                          trim
                          placeholder="best offer"
                          v-model="defaultCreateData.seoDescription"
                      />
                    </b-form-group>
                  </b-form>
                </b-col>
                <b-col cols="12">
                  <!--- serp Desktop --->
                  <div class="serp-preview d-lg-flex p-3 d-none flex-column align-items-start">
                    <div class="serp-title">
                      <h4 style="color: rgb(26, 13, 171) !important">
                        {{ defaultCreateData.seoTitle }}
                      </h4>
                    </div>
                    <div class="serp-url">
                      <!--              <span class="serp-arrow"></span>-->
                      <h5 class="d-flex align-items-center flex-wrap"
                          style="color: rgb(0, 102, 33) !important">
                        <span>
                          {{ `https://ariaexport.com/${entityType === '4' ? 'tag' : 'blogTag'}/` }}
                        </span>
                        <span style="overflow-wrap: anywhere">{{ allCharactersToDash }}</span>
                      </h5>
                    </div>
                    <div class="serp-description">
                      <h6 style="overflow-wrap: anywhere">
                        {{ defaultCreateData.seoDescription }}
                      </h6>
                    </div>
                  </div>
                  <!--- serp Mobile --->
                  <div class="serp-preview d-lg-none p-3 d-flex flex-column align-items-start">
                    <div class="serp-title">
                      <h6>
                        {{ defaultCreateData.seoTitle }}
                      </h6>
                    </div>
                    <div class="serp-url d-flex align-items-center flex-wrap">
                      <small>
                        {{ `https://ariaexport.com/${entityType === '4' ? 'tag' : 'blogTag'}/` }}
                        <!--                <small class="serp-arrow"></small>-->
                      </small>
                      <small>{{ allCharactersToDash }}</small>
                    </div>
                    <div class="serp-description">
                      <small>
                        {{ defaultCreateData.seoDescription }}
                      </small>
                    </div>
                  </div>
                </b-col>
                <b-col cols="2">
                  <b-button
                      @click="createTag"
                      variant="success"
                  >
                    <span class="text-nowrap">Create</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="tags"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="No items available"
        >
          <!-- Column: delete -->

          <template #cell(actions)="data">
            <div class="d-flex align-items-center" style="gap: 2rem">
              <div
                class="cursor-pointer"
                v-b-modal.modal-delete
                @click="showModal(data.item)"
              >
                <feather-icon size="20" icon="TrashIcon" class="text-danger" />
              </div>
            </div>
          </template>
        </b-table>
      </b-card>
    </div>
    <!-- Delete Modal Start -->
    <b-modal
        id="modal-delete"
        centered
        ok-variant="danger"
        title="Delete a category"
        ok-title="Delete"
        cancelTitle="Dismiss"
        @ok="deleteCategory"
    >
      <span>Are you sure you want to remove this item?</span>
    </b-modal>
    <!-- Delete Modal End -->
  </b-overlay>
</template>

<script>
import {
  BContainer,
  BCard,
  BRow,
  BCol,
  BForm,
  BFormRow,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BModal, BFormTextarea,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  BlogCategoryGetAllRequest,
  BlogCategoryCreateRequest,
  BlogCategoryDeleteRequest,
} from "@/libs/Api/BlogCategory";
import AddEditDeleteButton from "@/views/components/utils/AddEditDeleteButton.vue";
import {GetAllLangs} from "@/libs/Api/Language";
import {TagAddTagToEntity, TagGetEntityTypeTagsByObjectId, TagRemoveTagFromEntity} from "@/libs/Api/TagRequest";
import {ValidationProvider} from "vee-validate";

export default {
  name: "Tag",
  data() {
    return {
      languageList:[],
      isLoading: false,
      tags: null,
      totalCount: null,
      addNewCategory: false,
      tempPage: null,
      currentPage: 1,
      perPage: 10,
      myTableColumns: [
        {
          key: "tagId",
          label: "id",
        },
        {
          key: "tagName",
          label: "Name",
        },
        {
          key: "actions",
          label: "Actions",
        },
      ],
      defaultCreateData: {
        entityType:this.entityType,
        entityId: this.objectId,
        tagName: null,
        languageId: this.languageId,
        seoUrl:null,
        seoTitle:null,
        seoDescription:null
      },
    };
  },
  computed:{
    allCharactersToDash: {
      get: function () {
        return this.defaultCreateData.seoUrl;
      },
      set: function (newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.defaultCreateData.seoUrl = newValue
          // Remove all characters that are NOT number
          this.defaultCreateData.seoUrl = this.defaultCreateData.seoUrl.replace(/[+*!@#$%^&*()_;:~`»«,×='"|<>/?{}\/\.]/g, "");
          this.defaultCreateData.seoUrl = this.defaultCreateData.seoUrl.replaceAll(' ', '-')
        } else if (!newValue || this.defaultCreateData.seoUrl === "") {
          this.defaultCreateData.seoUrl = null;
        }
      },
    },
  },
  watch: {
    currentPage: {
      handler(val) {
        this.getTags();
      },
    },
  },
  props:{
    objectId:{
      required: true,
    },
    entityType:{
      required: true,
    },
    languageId:{
      required: true,
    }
  },
  async created() {
    await this.getTags();
  },
  methods: {
    async getTags() {
      try {
        this.isLoading = true;
        let _this = this;

        let tagGetEntityTypeTagsByObjectId = new TagGetEntityTypeTagsByObjectId(_this);
        tagGetEntityTypeTagsByObjectId.setRequestParam({
          objectId: _this.objectId,
          entityType: _this.entityType,
        });
        await tagGetEntityTypeTagsByObjectId.fetch(
            function (response) {
              if (response.isSuccess) {
                _this.tags = response.data;
              }
            },
            function (content) {
              console.log(content);
            }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async createTag() {
      try {
        this.isLoading = true;
        let _this = this;
        let tagAddTagToEntity = new TagAddTagToEntity(_this);
        tagAddTagToEntity.setParams(_this.defaultCreateData);
        await tagAddTagToEntity.fetch(
            function (response) {
              if (response.isSuccess) {
                _this.$toast({
                  component: ToastificationContent,
                  position: "bottom-center",
                  props: {
                    title: "Operation Was Successful",
                    icon: "CheckIcon",
                    variant: "success",
                    text: "Category Created Successfully",
                  },
                });
                _this.defaultCreateData = {
                  entityType:_this.entityType,
                  entityId: _this.objectId,
                  tagName: null,
                  languageId: _this.languageId,
                  seoUrl:null,
                  seoTitle:null,
                  seoDescription:null
                };
                _this.getTags();
              }
            },
            function (error) {
              console.log(error);
            }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async deleteCategory() {
      try {
        this.isLoading = true;
        let _this = this;

        let tagRemoveTagFromEntity = new TagRemoveTagFromEntity(_this);
        tagRemoveTagFromEntity.setParams({
          entityId: _this.objectId,
          entityType: _this.entityType,
          tagId:_this.tempPage.tagId
        });
        await tagRemoveTagFromEntity.fetch(
            function (response) {
              if (response.isSuccess) {
                _this.$toast({
                  component: ToastificationContent,
                  position: "bottom-center",
                  props: {
                    title: "Operation Was Successful",
                    icon: "CheckIcon",
                    variant: "success",
                    text: "Category Deleted Successfully",
                  },
                });
                _this.getTags();
              }
            },
            function (error) {
              console.log(error);
            }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    showModal(page) {
      this.tempPage = JSON.parse(JSON.stringify(page));
      this.$bvModal.show("modal-delete");
    },
  },
  components: {
    ValidationProvider, BFormTextarea,
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BFormRow,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,
    vSelect,
    AddEditDeleteButton,
  },
};
</script>

<style scoped></style>
